import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = getLatestArticles(4);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
              最新文章
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门资讯与使用指南
            </h2>
          </div>
          <Link
            to="/category"
            className="whitespace-nowrap inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-100/70 rounded-lg overflow-hidden hover:bg-background-100 transition-colors group"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}